<!--suppress ALL -->
<style>
    .vdp-datepicker__calendar .cell.selected {
        background: #78b800!important;
        color: #fff!important;
    }
</style>

<template>
    <div>
        <label v-bind:for="id" v-html="label"></label>
f
    </div>
</template>

<script>

    import Datepicker from 'vuejs-datepicker';
    import * as lang from "vuejs-datepicker/src/locale";
    var moment = require('moment');

    export default {
        components: {
            Datepicker
        },
        name: 'input-data',
        props: {
            options: {
                type: Object,
                default: () => ({}),
            }
        },

        data() {

            return {
                dataLimite: moment(moment().add(46, 'days').calendar(), 'MM-DD-YYYY').format('YYYY-MM-DD'),
                dataAtual: moment().format("YYYY-MM-DD"),
                disabledDates: {},
                name: (this.options.name) ? this.options.name : 'data',
                id: (this.options.id) ? this.options.id : 'data',
                value: (this.options.value) ? this.options.value : '',
                placeholder: (this.options.placeholder) ? this.options.placeholder : 'DD/MM/AAAA',
                label: (this.options.label) ? this.options.label : 'Data 1° Parcela',
                classe: (this.options.class) ? 'form-control ' + this.options.class : 'form-control',
                required: (this.options.required) ? true : false,
                disabled: (this.options.disabled) ? true : false,
                format: (this.options.format) ? this.options.format : 'dd/MM/yyyy',
                language: "pt-br",
                languages: lang,
                minimumView: (this.options.minimumView) ? this.options.minimumView : 'day',
                maximumView: (this.options.minimumView) ? this.options.maximumView : 'year',
            };
        },

        mounted () {
        this.disabledDates.to = new Date(this.dataAtual);
        this.disabledDates.from = new Date(this.dataLimite);

            var $this = this;
            setTimeout(function() {
                $('#'+$this.id).attr('autocomplete','off');
                $('#'+$this.id).val($this.value);
                $('#'+$this.id).removeAttr('readonly');
            }, 100);
        }

    }
</script>



// WEBPACK FOOTER //
// src/components/inputs/Date.vue